"use strict";
exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map


//////////////////
// WEBPACK FOOTER
// /Users/ggueret/Desktop/Personnel/Angular/ares-app/~/rxjs/util/isArray.js
// module id = ../../../../rxjs/util/isArray.js
// module chunks = 3